export default __webpack_public_path__ + "static/media/404.726c10f2.png";